import { useApiQuery } from 'mf_core/query';
import { Gateway } from './useCMPCardCheck';

export const tokensUrlMap = {
  CYBERSOURCE: '/payment/v1/gateways/cybersource/tokens',
  DOCDATA: '/payment/v1/gateways/DocDataDirectDebit/tokens',
  WORLDPAY: '/payment/v1/gateways/worldpay/tokens?getAllTokens=true',
};

export function usePaymentCards(enabled: boolean, gateway?: Gateway) {
  const tokensUrl = gateway ? tokensUrlMap[gateway] : '';
  return useApiQuery<any>(tokensUrl, undefined, {
    enabled,
    refetchOnWindowFocus: false,
  });
}
